import { render, staticRenderFns } from "./BeVenueHeader.vue?vue&type=template&id=16cb403f&scoped=true"
import script from "./BeVenueHeader.vue?vue&type=script&lang=js"
export * from "./BeVenueHeader.vue?vue&type=script&lang=js"
import style0 from "./BeVenueHeader.vue?vue&type=style&index=0&id=16cb403f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb403f",
  null
  
)

export default component.exports